import type { UploadFileProps } from "./upload-file.type";

import { UploadOutlined } from "@ant-design/icons";
import { Button, Typography, Upload } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import UploadFileTypesInfo from "./upload-file-types-info";
import { useUploadFile } from "./upload-file.hook";

import "./upload-file.style.less";

const { Text } = Typography;

const UploadFile = (props: UploadFileProps) => {
  const { t } = useTranslation();

  const { authorizedFileTypes, uploadProps, layout, texts } =
    useUploadFile(props);

  if (layout === "button") {
    return (
      <div className="upload-file">
        <Upload data-testid="upload-file-button" {...uploadProps}>
          <Button icon={<UploadOutlined />}>{t("global:upload.button")}</Button>
        </Upload>
      </div>
    );
  }

  return (
    <div className="upload-file">
      <Upload.Dragger data-testid="upload-file-dragger" {...uploadProps}>
        <div
          className={classNames(
            "upload-file-dragger-content",
            `-layout-${layout}`
          )}
        >
          <UploadOutlined className="upload-file-dragger-icon" />
          <div>
            <Text className="upload-file-dragger-title">{texts.title}</Text>
            <div className="upload-file-dragger-infos">
              {texts.maxSize && <Text>{texts.maxSize}</Text>}
              <UploadFileTypesInfo authorizedFileTypes={authorizedFileTypes} />
            </div>
          </div>
        </div>
      </Upload.Dragger>
    </div>
  );
};

export default UploadFile;
